import type { TOC } from '@ember/component/template-only';

import NotificationsTableComponent from 'webapp/components/notifications/table';

const SettingsNotificationsRouteTemplate: TOC<object> = <template>
	<NotificationsTableComponent />
</template>;

export default SettingsNotificationsRouteTemplate;
